exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/01.Developer/0.Web/Bravo8-Base/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main